import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./index.css";
import AOS from "aos";
import "aos/dist/aos.css";

const HeroSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="hero-section">
      <Container fluid>
        <Row className="h-100 align-items-center">
          {/* <Col className="text-container">
            <p className="hero_subtitle" data-aos="fade-up">
              {" "}
              {"We do  Cardiac Vascular and Neurological assessment, Allergy testing and treatment and not restricitng to Neuro feedback, Ultra sound and remote patient monitoring."}
              
            </p>
            <p
              className="hero_subtitle"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              {" "}
              
              You may be at risk for serious health problems <br />
              that often occur without any symptoms. Find a <br />
              KUR Diagnostics location near you!
            </p>
          </Col> */}

          <Col className="text-container1">
            <div className="hero_text_block" data-aos="fade-up">
              <p>
                We do Cardiac Vascular and Neurological assessment, Allergy testing and treatment,
                and not restricting to Neuro feedback, Ultra sound and remote patient monitoring.
              </p>

              {/* <p data-aos="fade-up" data-aos-delay="200">
                You may be at risk for serious health problems that often occur without any symptoms.
                Find a KUR Diagnostics location near you!
              </p> */}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default HeroSection;
